import * as Yup from 'yup'



export const validationSchemas = (isModoContacto,isModoRespuesta,isContacto) => {
   
  let validationObject = { };
  if(isContacto){
    validationObject["codHitoContacto"] = Yup.date().required('Este Campo es obligatorio.');
  }else{
    validationObject["codHitoRespuesta"] = Yup.date().required('Este Campo es obligatorio.');
    

  }
  if(isModoContacto){

  }
  if(isModoRespuesta){

   validationObject["fechaHitoRespuesta"] = Yup.date().required('La Fecha es obligatoria.');
  }

  return Yup.object().shape(validationObject);
}

